import { ChangeDetectionStrategy, Component, inject, input, output } from '@angular/core';
import { DelayedFileUploadItem } from "../../types/delayed-file-upload-card.types";
import { UploadProgressService } from "../../../../../../core/services/upload-progress.service";
import { FileProgressBarStatusComponent } from "../../../file-progress-bar-status/file-progress-bar-status.component";
import { MatIconButton } from "@angular/material/button";
import { MatTooltip } from "@angular/material/tooltip";
import { MatIcon } from "@angular/material/icon";

@Component({
  selector: 'app-delayed-file-upload-item',
  standalone: true,
  templateUrl: './delayed-file-upload-item.component.html',
  styleUrl: './delayed-file-upload-item.component.scss',
  imports: [
    FileProgressBarStatusComponent,
    MatIconButton,
    MatTooltip,
    MatIcon
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DelayedFileUploadItemComponent {
  delayedFileUploadItem = input.required<DelayedFileUploadItem>();
  deleteFile = output<number>();

  public uploadProgressService: UploadProgressService = inject(UploadProgressService);

  public handleDeleteFile(): void {
    this.deleteFile.emit(this.delayedFileUploadItem().index);
  }
}
